import type { FormControl, ValidatorFn } from '@angular/forms';

import { Node as ProsemirrorNode } from 'prosemirror-model';

import type { IProsemirrorConfig } from '@core/prosemirror-legacy';

export const noWhitespaceValidatorFactory = (config: IProsemirrorConfig): ValidatorFn => {
  const schema = config.getSchema();

  return (control: FormControl) => {
    const json = control.value;
    const node = json ? ProsemirrorNode.fromJSON(schema, json.doc) : null;
    const isValid = node ? isNodeEmpty(node) : false;
    return isValid ? null : { whitespace: true };
  };
};

const isNodeEmpty = (node: ProsemirrorNode): boolean => {
  if (!node || (node.isTextblock && node.textContent.trim() === '')) {
    return true;
  }

  if (node.childCount === 0) {
    return true;
  }

  for (let i = 0; i < node.childCount; i++) {
    const child = node.child(i);
    if (!isNodeEmpty(child)) {
      return false;
    }
  }

  return true;
};
